import { render } from "./ViewCatalog.vue?vue&type=template&id=3cab1731&scoped=true&ts=true"
import script from "./ViewCatalog.vue?vue&type=script&lang=ts"
export * from "./ViewCatalog.vue?vue&type=script&lang=ts"

import "./ViewCatalog.vue?vue&type=style&index=0&id=3cab1731&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cab1731"]])

export default __exports__